import React from 'react';
import { Document, Page, Text, View } from '@react-pdf/renderer';
import styles from '../styles';
import { appNames, reportingStandards } from '../../constants';
import { HeaderOTCQX } from '../headers';
import { Footer } from '../components';
import Cover from '../pages/Cover';
import CompanyInfo from '../pages/CompanyInfo';
import ReportingStandards from '../pages/ReportingStandards';
import AdditionalServices from '../pages/AdditionalServices';
import EligibilityStandards from '../pages/EligibilityStandards';
import Officers from '../pages/Officers';
import Directors from '../pages/Directors';
import ControlPersonIndividual from '../pages/ControlPersonIndividual';
import ControlPersonCorpEntity from '../pages/ControlPersonCorpEntity';
import SPTransferAgent from '../pages/SPTransferAgent';
import SPAuditor from '../pages/SPAuditor';
import SPSecCounsel from '../pages/SPSecCounsel';
import SPCorpBroker from '../pages/SPCorpBroker';
import SPInvestorRelationsServices from '../pages/SPInvestorRelationsServices';
import SPInvestmentBank from '../pages/SPInvestmentBank';
import SecurityDetails from '../pages/SecurityDetails';
import SecurityOwnership from '../pages/SecurityOwnership';
import LegalDisciplinaryHistory from '../pages/LegalDisciplinaryHistory';
import PrimaryContacts from '../pages/PrimaryContacts';
import AuthorizedUsers from '../pages/AuthorizedUsers';
import BillingContacts from '../pages/BillingContacts';
import BackgroundCheck from '../pages/BackgroundCheck';
import SuppDocsRequired from '../pages/SuppDocsRequired';
import SuppDocsAdditional from '../pages/SuppDocsAdditional';
import PaymentDetails from '../pages/PaymentDetails';

const OTCQX_BANKS = appNames.OTCQX_BANKS;

const TemplateOTCQXBanks = ({ application, documents, owners, docTypes, appStates }) => {
  const status = application && application.status;
  const appStateObj = appStates && appStates.find(state => state.stateId === status);
  const statusDesc = appStateObj && appStateObj.description || application.status;
  const symbol = application && application.primarySymbol;
  const companyName = application && application.companyInfo && application.companyInfo.name;
  const isIntlReportStnd = application && application.reportingStandard === reportingStandards.INTERNATIONAL;
  const draftMgCertRequired = !isIntlReportStnd;

  return (
    <Document style={styles.document} >
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <Cover type={OTCQX_BANKS} status={statusDesc} symbol={symbol} symbolType={'OTCQX'} companyName={companyName} owners={owners} people={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <CompanyInfo data={application.companyInfo} type={OTCQX_BANKS} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <EligibilityStandards data={application.eligibilityStandards} type={OTCQX_BANKS} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <ReportingStandards data={application.reportingStandard} detail={application.reportingStandardDetail} cik={application.cikNumber} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <Officers data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <Directors data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <ControlPersonIndividual data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <ControlPersonCorpEntity entities={application.corporateEntityList} people={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <SecurityDetails data={application.securityDetails} type={OTCQX_BANKS} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <SecurityOwnership people={application.peopleList} entities={application.corporateEntityList} securities={application.securityDetails && application.securityDetails.securityList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <LegalDisciplinaryHistory data={application.legalHistory} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <PrimaryContacts data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <AuthorizedUsers data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <BillingContacts data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <BackgroundCheck type={OTCQX_BANKS} people={application.peopleList} entities={application.corporateEntityList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <SPTransferAgent data={application.transferAgents} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <SPAuditor data={application.auditors} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <SPSecCounsel data={application.securitiesCounsels} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <SPCorpBroker data={application.corporateBroker} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <SPInvestorRelationsServices data={application.investorRelations} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <SPInvestmentBank data={application.investmentBanks} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <SuppDocsRequired docs={documents} docTypes={docTypes} shareHoldRequired auditAnnualReportRequired logoRequired draftMgCertRequired={draftMgCertRequired} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <SuppDocsAdditional docs={documents} docTypes={docTypes} shareHoldRequired auditAnnualReportRequired logoRequired draftMgCertRequired={draftMgCertRequired} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <AdditionalServices data={application.additionalServices} hasVIC />
        <Footer companyName={companyName} />
      </Page>
      {application.payment && <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_BANKS} />
        <PaymentDetails data={application.payment} submitDate={application.submitDate} />
        <Footer companyName={companyName} />
      </Page>}
    </Document>
  );
};

export default TemplateOTCQXBanks;
